import React, { useState } from "react";
import { Link } from "react-router-dom";
import LazyImage from "../components/Ui/LazyImage";

const HiringTips = () => {
  const [expanded, setExpanded] = useState(null);

  const tips = [
    {
      title: "Write a clear job description",
      summary:
        "Be specific about responsibilities, required skills, and what success looks like.",
      body:
        "Include must-have vs nice-to-have skills, level (junior/senior), and clear responsibilities. This reduces unqualified applicants and improves match rates.",
      img: require("../Assets/image/5093164.jpg"),
    },
    {
      title: "Highlight your company culture",
      summary: "Share values, perks, and the work environment to attract candidates.",
      body:
        "Talk about values, team rituals, remote/hybrid policies, and career growth — candidates who align culturally stay longer.",
      img: require("../Assets/image/rafiki.png"),
    },
    {
      title: "Use structured interviews",
      summary: "Ask the same core questions and score answers to reduce bias.",
      body:
        "Structured interviews increase hiring predictability. Use a rubric and train interviewers to score consistently.",
      img: require("../Assets/image/docare1.png"),
    },
    {
      title: "Provide timely feedback",
      summary:
        "Keep candidates informed during the process — it improves their experience and your brand.",
      body:
        "Automate status updates where possible and set expectations on timelines. Fast feedback reduces drop-off and keeps top talent engaged.",
      img: require("../Assets/image/right.png"),
    },
    {
      title: "Optimize your hiring funnel",
      summary:
        "Track conversion at each step (apply, screen, interview, offer) and remove friction.",
      body:
        "Use metrics to find drop-off points. Simplify your application form, and prioritize high-impact interviews to speed time-to-hire.",
      img: require("../Assets/image/ProfileImage.png"),
    },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Link to="/" className="text-sm text-blue-600 underline">
        &larr; Back
      </Link>
      <h1 className="text-3xl font-bold mt-4 mb-6">Hiring Tips</h1>

      <p className="text-gray-700 mb-6">
        A short, practical guide to improve your hiring process. Click any tip
        to read more — images and extra content load only when you expand a tip.
      </p>

      <div className="grid gap-4">
        {tips.map((t, idx) => (
          <article
            key={idx}
            className="border rounded-md p-4 hover:shadow-md transition-shadow bg-white"
          >
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <h2 className="font-semibold text-lg">{t.title}</h2>
                <p className="text-gray-600 mt-2">{t.summary}</p>
              </div>
              <div className="flex-shrink-0 ml-4">
                <button
                  onClick={() => setExpanded(expanded === idx ? null : idx)}
                  className="text-sm text-blue-600 underline"
                >
                  {expanded === idx ? "Collapse" : "Read more"}
                </button>
              </div>
            </div>

            {expanded === idx && (
              <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
                <div className="md:col-span-2">
                  <p className="text-gray-700">{t.body}</p>
                </div>
                <div className="md:col-span-1">
                  {/* Image only rendered when expanded to avoid unnecessary downloads */}
                  <LazyImage
                    src={t.img}
                    alt={t.title}
                    className="w-full h-40 object-cover rounded"
                  />
                </div>
              </div>
            )}
          </article>
        ))}
      </div>
    </div>
  );
};

export default HiringTips;
